<script>
  import { onMount } from "svelte";
  import Toast from "./Toast.svelte";
  import { toastStore } from "../../stores/toast.js";

  let toasts = $state([]);

  onMount(() => {
    const unsubscribe = toastStore.subscribe((value) => {
      toasts = value;
    });
    return unsubscribe;
  });

  function handleDismiss(id) {
    toastStore.dismiss(id);
  }
</script>

{#if toasts.length > 0}
  <div class="toast-container" role="region" aria-label="Notifications">
    {#each toasts as toast (toast.id)}
      <Toast {toast} onDismiss={handleDismiss} />
    {/each}
  </div>
{/if}

<style>
  .toast-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 100vw;
    z-index: var(--z-toast);
    display: flex;
    flex-direction: column;
    pointer-events: none;
    overflow: hidden;
  }

  .toast-container > :global(*) {
    pointer-events: auto;
  }
</style>
